export const wordsAlgorithm = [
    "Кра|ски",
    "Каран|даш",
    "Ку|бики",
    "Ци|кл",
    "Ветв|ление",
    "Алго|ритм",
    "Испол|нитель",
    "Блок-|схема",
    "Ло|гика",
    "Зада|ча",
    "Коман|да",
    "Прог|рамма",
    "Кот|обот",
    "От|ладка",
    "Ре|шение",
    "За|пуск"
  ];